export enum Operation {
  // 删除
  DELETE = 'delete',
  // 批量删除
  BATCHDE = 'batchDelete',
  // 修改
  REVISE = 'revise',
  // 单个上传
  SINUPLOAD = 'sinUpload',
  // 批量上传
  BATCHUPLOAD = 'batchUpload',
  // 下载
  DOWNLOAD = 'download',
  // 是否公开
  ISOPEN = 'public',
  // 上下架
  UPLOW = 'show_status',
  // 修改版权
  COPYRIGHT = 'copyright',
  // 应用范围
  APPLICABLETOOL = 'applicable_tools',
  // 添加标签
  ADDLABEL = 'addLabel',
  // 移除标签
  DELABEL = 'deLabel',
  // 添加粒子
  ADD_PARTICLE = 'add_particle',
  // 文本预设
  ADD_FLOWERWORD = 'add_flowerword',
  // af上传资源
  AF_UPLOAD = 'af_upload',
  // 审核
  AUDIT = 'audit',
  // 修改标签
  TAGS = 'tags',
}

export enum TabsType {
  ALL = 0, // 全部
  VIDEO, // 视频
  PICTURE, // 图片
  GRAPH, // 动图
  AUDIO, // 音频
  PARTICLE, // 粒子
  FONT, // 字体
  KEEL, // 龙骨
  FLOWERWORD, // 花字
  TRANSITION, // 转场
  FILTER, // 滤镜
  ANIMATION, // 动画
  PRESETS, // 预设
  FRAGMENT, // 片段
  MODEL, // 模型
  ACTION, // 动作
}

export enum ApplicableResourcesType {
  VIDEOPICTURE = 1, // 视频、图片
  TAG, // 贴纸
  TEXT, // 文字
}

export enum AuditStatusType {
  // 编辑中
  edit = 'edit',
  // 已提交，待审核
  waitReview = 'wait_review',
  // 渲染中
  review = 'review',
  // 渲染失败
  review_failed = 'review_failed',
  // 审核通过
  approved = 'approved',
  // 审核不通过
  rejected = 'rejected',
}
